import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createAuth0 } from '@auth0/auth0-vue';
import router from './router'

loadFonts()

createApp(App)
  .use(
    createAuth0({
      domain: process.env.VUE_APP_AUTH0_DOMAIN,
      client_id: process.env.VUE_APP_AUTH0_CLIENT_ID, 
      redirect_uri: window.location.origin,
      audience: process.env.VUE_APP_AUTH0_AUDIENCE ,
      cacheLocation: 'localstorage',
    })
  )
  .use(vuetify)
  .use(router)
  .mount('#app')